import validator from "validator"
import validAreaCodes from "./validAreaCodes"
import Swal from "sweetalert2"
const digitsOnly = value => value.replace(/[^\d]/g, "")

function formatPhoneNumber(value) {
  if (!value) return value
  const phoneNumber = digitsOnly(value)

  const phoneNumberLength = phoneNumber.length

  if (phoneNumberLength < 4) return phoneNumber
  if (phoneNumberLength < 7) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`
  }
  return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6, 10)}`
}
function checkForPhoneNumberError(value) {
  if (
    !value ||
    value[0] === "1" ||
    digitsOnly(value).length > 10 ||
    !validAreaCodes.find(areaCode => value.startsWith(`${areaCode}`))
  ) {
    return "please enter a valid phone number"
  }
  return null
}

const helpers = {
  //    Patient Form Validation
  validateWelcomeVisitBadDate: function (e, setErrField, setUser, user) {
    if (e.target.name === "zipCode") {
      const re = /^[0-9\b]+$/
      if (e.target.value === "" || re.test(e.target.value)) {
        if (e.target.value.length <= 5) {
          setUser({
            ...user,
            [e.target.name]: e.target.value,
          })
        }
      }
    } else if (e.target.name === "name") {
      if (e.target.value.length === 1 && e.target.value === " ") {
        setErrField(prevState => ({
          ...prevState,
          nameErr: "This field is required",
        }))
      } else {
        if (e.target.value.match(/[^a-zA-Z-' ]/)) {
          setErrField(prevState => ({
            ...prevState,
            nameErr: "",
          }))
        } else {
          if (e.target.value === "") {
            setErrField(prevState => ({
              ...prevState,
              nameErr: "This field is required",
            }))
            setUser({
              ...user,
              [e.target.name]: e.target.value,
            })
          } else {
            setUser({
              ...user,
              [e.target.name]: e.target.value,
            })
          }
        }
      }
    } else if (e.target.name === "lastName") {
      if (e.target.value === "") {
        setErrField(prevState => ({
          ...prevState,
          lastNameErr: "This field is required",
        }))
        setUser({
          ...user,
          [e.target.name]: e.target.value,
        })
      } else {
        if (e.target.value.match(/[^a-zA-Z-' ]/)) {
          setErrField(prevState => ({
            ...prevState,
            lastNameErr: "",
          }))
        } else {
          if (e.target.value.length === 1 && e.target.value === " ") {
            setErrField(prevState => ({
              ...prevState,
              lastNameErr: "This field is required",
            }))
          } else {
            setUser({
              ...user,
              [e.target.name]: e.target.value,
            })
          }
        }
      }
    } else if (e.target.name === "city") {
      if (e.target.value.length === 1 && e.target.value === " ") {
        setErrField(prevState => ({
          ...prevState,
          cityErr: "Space not allow on starting.",
        }))
      } else {
        if (e.target.value.match(/[^a-zA-Z-' ]/)) {
          setErrField(prevState => ({
            ...prevState,
            cityErr: "Number is not allowed.",
          }))
        } else {
          setUser({
            ...user,
            [e.target.name]: e.target.value,
          })
        }
      }
    } else {
      setUser({
        ...user,
        [e.target.name]: e.target.value,
      })
    }
  },
  validatePatientForm: function (setErrField, user) {
    let formIsvalid = true
    setErrField({
      nameErr: "",
      lastNameErr: "",
      address1Err: "",
      address2Err: "",
      cityErr: "",
      stateErr: "",
      countryErr: "",
      zipCodeErr: "",
      genderErr: "",
      birthdateErr: "",
    })
    if (user.name === "") {
      formIsvalid = false
      setErrField(prevState => ({
        ...prevState,
        nameErr: "please enter first name.",
      }))
    }
    if (user.name.match(/\d+/g)) {
      formIsvalid = false
      setErrField(prevState => ({
        ...prevState,
        nameErr: "Did not allow numbers",
      }))
    }
    if (user.lastName === "") {
      formIsvalid = false
      setErrField(prevState => ({
        ...prevState,
        lastNameErr: "please enter last name.",
      }))
    }
    if (user.gender === "") {
      formIsvalid = false
      setErrField(prevState => ({
        ...prevState,
        genderErr: "please select gender.",
      }))
    }
    if (user.birthdate === "") {
      formIsvalid = false
      setErrField(prevState => ({
        ...prevState,
        birthdateErr: "please enter birth date.",
      }))
    }
    if (user.address1 === "") {
      formIsvalid = false
      setErrField(prevState => ({
        ...prevState,
        address1Err: "please enter address1.",
      }))
    }
    if (user.city === "") {
      formIsvalid = false
      setErrField(prevState => ({
        ...prevState,
        cityErr: "please enter city.",
      }))
    }
    if (user.country === "") {
      formIsvalid = false
      setErrField(prevState => ({
        ...prevState,
        countryErr: "please select country.",
      }))
    }
    if (user.state === "") {
      formIsvalid = false
      setErrField(prevState => ({
        ...prevState,
        stateErr: "please select state.",
      }))
    }
    if (user.zipCode === "") {
      formIsvalid = false
      setErrField(prevState => ({
        ...prevState,
        zipCodeErr: "please enter zip code.",
      }))
    }
    if (user.zipCode.match(" /^[0-9\b]+$/")) {
      formIsvalid = false
      setErrField(prevState => ({
        ...prevState,
        zipCodeErr: "please ujghftyufg zipCode.",
      }))
    }
    return formIsvalid
  },

  // Caregiver Form Validation
  validateWelcomeVisitOnChange: function (e, setErrField, setUser, user) {
    if (e.target.name === "zipCode") {
      const re = /^[0-9\b]+$/
      if (e.target.value === "" || re.test(e.target.value)) {
        if (e.target.value.length <= 5) {
          setUser({
            ...user,
            [e.target.name]: e.target.value,
          })
        }
      }
    } else if (e.target.name === "name") {
      if (e.target.value.match(/[^a-zA-Z-' ]/)) {
        setErrField(prevState => ({
          ...prevState,
          nameErr: "",
        }))
      } else {
        setUser({
          ...user,
          [e.target.name]: e.target.value,
        })
      }
    } else if (e.target.name === "lastName") {
      if (e.target.value.match(/[^a-zA-Z-' ]/)) {
        setErrField(prevState => ({
          ...prevState,
          lastNameErr: "",
        }))
      } else {
        setUser({
          ...user,
          [e.target.name]: e.target.value,
        })
      }
    } else if (e.target.name === "city") {
      if (e.target.value.match(/[^a-zA-Z ]/)) {
        setErrField(prevState => ({
          ...prevState,
          cityErr: "Number is not allowed.",
        }))
      } else {
        setUser({
          ...user,
          [e.target.name]: e.target.value,
        })
      }
    } else if (e.target.name === "phoneNumber") {
      const formattedPhoneNumber = formatPhoneNumber(e.target.value)
      setUser({
        ...user,
        [e.target.name]: formattedPhoneNumber,
      })
    } else if (e.target.name === "emailAddress") {
      setUser({
        ...user,
        [e.target.name]: e.target.value,
      })
      if (validator.isEmail(e.target.value) === true) {
        setErrField(prevState => ({
          ...prevState,
          emailAddressErr: "",
        }))
      }
    } else {
      setUser({
        ...user,
        [e.target.name]: e.target.value,
      })
    }
  },
  validateWelcomeVisitOnSubmit: async (
    setErrField,
    user,
    inputRef,
    setApiData
  ) => {
    let formIsvalid = true
    setErrField({
      address1Err: "",
      address2Err: "",
      cityErr: "",
      countryErr: "",
      emailAddressErr: "",
      lastNameErr: "",
      nameErr: "",
      phoneNumberErr: "",
      stateErr: "",
      zipCodeErr: "",
    })
    if (user.name === "") {
      formIsvalid = false
      setErrField(prevState => ({
        ...prevState,
        nameErr: "please enter first name.",
      }))
    }
    if (user.lastName === "") {
      formIsvalid = false
      setErrField(prevState => ({
        ...prevState,
        lastNameErr: "please enter last name.",
      }))
    }
    if (user.emailAddress === "") {
      formIsvalid = false
      setErrField(prevState => ({
        ...prevState,
        emailAddressErr: "please enter Email Address.",
      }))
    } else {
      if (validator.isEmail(user.emailAddress) === false) {
        formIsvalid = false
        setErrField(prevState => ({
          ...prevState,
          emailAddressErr: "Please Enter Valid Email Address.",
        }))
        inputRef.current.focus()
      }
    }

    const phoneNumberErr = checkForPhoneNumberError(user.phoneNumber)
    console.log(user, phoneNumberErr)
    if (phoneNumberErr) {
      const { value: confirmed } = await Swal.fire({
        title: "Error",
        text: `Please verify that ${user.phoneNumber} is a valid phone number`,
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: "Next step",
        cancelButtonText: "Go back",
        reverseButtons: true,
        confirmButtonColor: "#ffc156",
      })
      if (confirmed) {
        setApiData(d => ({ ...d, isValidPhoneNumber: false }))
      } else {
        formIsvalid = false
        setErrField(prevState => ({
          ...prevState,
          phoneNumberErr,
        }))
      }
    } else {
      setApiData(d => ({ ...d, isValidPhoneNumber: true }))
    }
    if (user.address1 === "") {
      formIsvalid = false
      setErrField(prevState => ({
        ...prevState,
        address1Err: "please enter address1.",
      }))
    }
    if (user.city === "") {
      formIsvalid = false
      setErrField(prevState => ({
        ...prevState,
        cityErr: "please enter city.",
      }))
    }
    if (user.country === "") {
      formIsvalid = false
      setErrField(prevState => ({
        ...prevState,
        countryErr: "please enter country.",
      }))
    }
    if (user.state === "") {
      formIsvalid = false
      setErrField(prevState => ({
        ...prevState,
        stateErr: "please enter state.",
      }))
    }
    if (user.zipCode === "") {
      formIsvalid = false
      setErrField(prevState => ({
        ...prevState,
        zipCodeErr: "please enter zip code.",
      }))
    }
    return formIsvalid
  },
  validateInsurancePlanOnChange: function (e, setErrField, setUser, user) {
    if (e.target.name === "insurance_phone") {
      const formattedPhoneNumber = formatPhoneNumber(e.target.value)
      setUser({
        ...user,
        [e.target.name]: formattedPhoneNumber,
      })
    } else {
      setUser({
        ...user,
        [e.target.name]: e.target.value,
      })
    }
    if (e.target.name === "plan_name") {
      if (e.target.value.length === 50) {
        setErrField(prevState => ({
          ...prevState,
          plan_nameErr: "A maximum length of only 50 characters is allowed",
        }))
      } else {
        setErrField(prevState => ({
          ...prevState,
          plan_nameErr: "",
        }))
      }
    }
  },
}

export default helpers
